import React, { Component } from 'react';
import '../Styles/css/News.css';

export default class News extends Component {

    render() {

        return (
            <div className="news">
                <h1>NEWS</h1>

                <div className="posts">
                    <div className="post">
                        <a className="title" href="https://www.thewildhoneypie.com/buzzing-daily/flaural-the-thinker">"The Thinker" Included on Buzzing Daily Playlist</a>
                        <span className="blog">The Wild Honey Pie</span>
                    </div>

                    <div className="post">
                        <a className="title" href="https://www.stereogum.com/2032822/flaural-the-thinker-postponement/premiere/">Flaural Announce Debut 'Postponement,' Hear "The Thinker"</a>
                        <span className="blog">Stereogum</span>
                    </div>

                    <div className="post">
                        <a className="title" href="https://www.indieshuffle.com/flaural-bounders/">'Bounders' Featured on Nice Life SUMMER '18 Playlist</a>
                        <span className="blog">Indie Shuffle</span>
                    </div>

                    <div className="post">
                        <a className="title" href="https://www.indieshuffle.com/flaural-nonnie/">Premiere - 'Nonnie'</a>
                        <span className="blog">Indie Shuffle</span>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Containers/News.js